import React from 'react';
import Vegetatsiya from './veg/Index'
import Novegetatsiya from './noveg/Index'
import {NavLink, useParams} from "react-router-dom";
import {HomeOutlined} from '@ant-design/icons'
function Index(props) {
    const params = useParams()
    const season = localStorage.getItem('sfr-hm-season')
    return (
        <div className="row">
            <div className="col-12" style={{position:"sticky",top:"-12px",zIndex:"3"}}>
                <div className="xisobotlar-menu bg-white" style={{margin:"2px -20px"}}>
                    <ul>
                        <li><NavLink to="/sfr/gidromodul" className="d-flex align-items-center"><HomeOutlined/></NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new">Ekin tanlash</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/insert">Ma'lumot kiritish</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/limits">Limitlar</NavLink></li>
                    </ul>
                    <ul>
                        <li><NavLink to="/sfr/gidromodul/new/reports" className={params['*'] == ''?'activ':''}>Jadval №1</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports/table2" className={params['*'] == 'table2'?'activ':''}>Jadval №1 a</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports/table3" className={params['*'] == 'table3'?'activ':''}>Jadval №2 a</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports/table4" className={params['*'] == 'table4'?'activ':''}>Jadval №2 b</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports/table5" className={params['*'] == 'table5'?'activ':''}>Jadval №3</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports/table6" className={params['*'] == 'table6'?'activ':''}>Jadval №3 a</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports/table7" className={params['*'] == 'table7'?'activ':''}>Jadval №4</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports/table8" className={params['*'] == 'table8'?'activ':''}>Jadval №4 a</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports/table9" className={params['*'] == 'table9'?'activ':''}>Jadval №5</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports/table10" className={params['*'] == 'table10'?'activ':''}>Jadval №5 a</NavLink></li>
                    </ul>
                </div>
            </div>

            <div className="col-12" style={{position:"static",zIndex:"2"}}  id="tblData">
                {
                    season == 'veg'?<Vegetatsiya/>:<Novegetatsiya/>
                }
            </div>
        </div>
    );

}

export default Index;